import {NgModule} from '@angular/core';
import {DashboardComponent} from './dashboard.component';
import {RouterModule} from '@angular/router';
import {SharedModule} from '@app/shared/shared.module';
import {LayoutModule} from '@app/shared/layout/layout.module';
import {ComponentModule} from '@app/shared/component/component.module';
import {LineItemsComponent} from '@app/shared/component/line-items/line-items.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild([{
      path: '',
      component: DashboardComponent
    }]),
    LayoutModule,
    ComponentModule,
  ],
  declarations: [DashboardComponent, LineItemsComponent],
})
export class DashboardModule {
}
